import { render, staticRenderFns } from "./GCP.vue?vue&type=template&id=ae2a1b52&"
import script from "./GCP.vue?vue&type=script&lang=js&"
export * from "./GCP.vue?vue&type=script&lang=js&"
import style0 from "./GCP.vue?vue&type=style&index=0&id=ae2a1b52&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports